import { createSlice } from "@reduxjs/toolkit";
import { fetchBaseData } from "../loadedContent/loadedContentSlice";
export const defaultPositions = [
    { category: "Attackers", label: "LW", id: 0 },
    { category: "Attackers", label: "ST", id: 1 },
    { category: "Attackers", label: "RW", id: 2 },
    { category: "Midfielders", label: "LM", id: 3 },
    { category: "Midfielders", label: "CAM", id: 4 },
    { category: "Midfielders", label: "RM", id: 5 },
    { category: "Midfielders", label: "CDM", id: 6 },
    { category: "Midfielders", label: "CM", id: 7 },
    { category: "Defenders", label: "LB", id: 8 },
    { category: "Defenders", label: "CB", id: 9 },
    { category: "Defenders", label: "RB", id: 10 },
    { category: "Defenders", label: "GK", id: 11 },
];
// Stable Tier objects to avoid returning a new reference each time
const TIER_MAP = {
    0: {
        tierName: "S",
        tierColor: "bg-primary-light-blue",
        tierTextColor: "#00C2FF",
        splitTierName: ["S"],
    },
    1: {
        tierName: "A+",
        tierColor: "bg-ea-dark-green",
        tierTextColor: "#1ab25c",
        splitTierName: ["A", "+"],
    },
    2: {
        tierName: "A",
        tierColor: "bg-ea-light-green",
        tierTextColor: "#00f43e",
        splitTierName: ["A"],
    },
    3: {
        tierName: "B+",
        tierColor: "bg-tier-yellow",
        tierTextColor: "#ffe105",
        splitTierName: ["B", "+"],
    },
    4: {
        tierName: "B",
        tierColor: "bg-ea-orange",
        tierTextColor: "#ec9e0c",
        splitTierName: ["B"],
    },
};
export const getTier = (playerRoles, metaRating, playerRoleId) => {
    const playerRole = playerRoles.find((a) => a.id === playerRoleId);
    if (!playerRole)
        return null;
    const roundedMetaRating = Math.round(metaRating * 10) / 10;
    const tier = playerRole.metaTiers.find((t) => roundedMetaRating >= t.minMetaRating);
    if (!tier)
        return null;
    return TIER_MAP[tier.tierId];
};
// Initial state
const initialState = {
    playerRoles: [],
    initialPlayerDataStatus: "idle",
    playStylesDict: {},
};
// Create the slice
const playersSlice = createSlice({
    name: "players",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchBaseData.fulfilled, (state, action) => {
            state.playStylesDict = action.payload.playStyles;
            state.playerRoles = action.payload.playerRoles;
            state.initialPlayerDataStatus = "fulfilled";
        });
        builder.addCase(fetchBaseData.pending, (state) => {
            state.initialPlayerDataStatus = "pending";
        });
        builder.addCase(fetchBaseData.rejected, (state) => {
            state.initialPlayerDataStatus = "rejected";
        });
    },
});
export const playerRoleLabelSelector = ({ playerRoleId, appendPosition = true, shortName = false, }) => (state) => {
    const playerRole = state.playersReducer.playerRoles.find((pr) => pr.id === playerRoleId);
    if (!playerRole)
        return "";
    if (!appendPosition)
        return playerRole.name;
    if (shortName)
        return playerRole.shortName + " " + playerRole?.position;
    return playerRole?.name
        ? playerRole?.name + " " + playerRole?.position
        : "";
};
export const playerRolesSelector = (state) => state.playersReducer.playerRoles;
/**
 * "Poacher ST" for a graded role, "Best Role" when none is selected (or the id
 * doesn't resolve). The label both Compare hosts show on the role trigger.
 */
export const compareRoleLabelSelector = (playerRoleId) => (state) => {
    const role = state.playersReducer.playerRoles.find((r) => r.id === playerRoleId);
    return role?.name ? `${role.name} ${role.position}` : "Best Role";
};
export const tierSelector = (metaRating, playerRoleId) => (state) => {
    const { playerRoles } = state.playersReducer;
    return getTier(playerRoles, metaRating, playerRoleId);
};
// Export reducer
export default playersSlice.reducer;
export const getPlayersSelector = (state) => state.playersReducer;
//# sourceMappingURL=playersSlice.js.map